import { WeaponDefSchema, type WeaponDef } from './schema';

const raw = [
  {
    id: 'fists',
    category: 'melee',
    ammo: 999,
    fireMode: 'semi',
    fireIntervalTicks: 20,
    projectile: { kind: 'melee', speed: 0, damage: 22, count: 1, gravity: 0, bounce: 0, fuse: 0, radius: 0.45, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 0, up: 0, forward: 4 },
    knockback: 6,
    thrownDamage: 0,
    dropWeight: 0,
    twoHanded: false,
    laserSight: false,
    infiniteAmmo: true,
    shape: { kind: 'fists', length: 0.2 },
    sound: 'punch',
    milestone: 'm2',
  },
  {
    id: 'pistol',
    category: 'pistol',
    ammo: 15,
    fireMode: 'semi',
    fireIntervalTicks: 6,
    projectile: { kind: 'bullet', speed: 60, damage: 32, spreadDeg: 2, count: 1, gravity: 0, bounce: 0, fuse: 0, radius: 0, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 0.5, up: 1, forward: 0 },
    knockback: 2,
    thrownDamage: 55,
    dropWeight: 1,
    twoHanded: false,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'pistol', length: 0.45 },
    sound: 'shot.small',
    milestone: 'm3',
  },
  {
    id: 'revolver',
    category: 'pistol',
    ammo: 6,
    fireMode: 'semi',
    fireIntervalTicks: 14,
    projectile: { kind: 'bullet', speed: 70, damage: 44, spreadDeg: 0.5, count: 1, gravity: 0, bounce: 0, fuse: 0, radius: 0, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 0.6, up: 2.2, forward: 0 },
    knockback: 3,
    thrownDamage: 55,
    dropWeight: 0.9,
    twoHanded: false,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'revolver', length: 0.5 },
    sound: 'shot.heavy',
    milestone: 'm3',
  },
  {
    id: 'deagle',
    category: 'pistol',
    ammo: 15,
    fireMode: 'semi',
    fireIntervalTicks: 10,
    projectile: { kind: 'bullet', speed: 72, damage: 56, spreadDeg: 1, count: 1, gravity: 0, bounce: 0, fuse: 0, radius: 0, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 1.4, up: 2.4, forward: 0 },
    knockback: 6,
    thrownDamage: 55,
    dropWeight: 0.5,
    twoHanded: false,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'deagle', length: 0.52 },
    sound: 'shot.heavy',
    milestone: 'm6',
  },
  {
    id: 'uzi',
    category: 'pistol',
    ammo: 40,
    fireMode: 'auto',
    fireIntervalTicks: 4,
    projectile: { kind: 'bullet', speed: 55, damage: 14, spreadDeg: 4, count: 1, gravity: 0, bounce: 0, fuse: 0, radius: 0, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 0.35, up: 0.4, forward: 0 },
    knockback: 2.5,
    thrownDamage: 55,
    dropWeight: 1,
    twoHanded: false,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'uzi', length: 0.48 },
    sound: 'shot.small',
    milestone: 'm3',
  },
  {
    id: 'god-pistol',
    category: 'pistol',
    ammo: 999,
    fireMode: 'semi',
    fireIntervalTicks: 18,
    projectile: { kind: 'bullet', speed: 28, damage: 45, spreadDeg: 0, count: 1, gravity: 0, bounce: 0, fuse: 0, radius: 0.2, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: true },
    recoil: { back: 1, up: 1, forward: 0 },
    knockback: 4,
    thrownDamage: 55,
    dropWeight: 0.12,
    twoHanded: false,
    laserSight: false,
    infiniteAmmo: true,
    shape: { kind: 'god-pistol', length: 0.6 },
    sound: 'shot.god',
    milestone: 'm6',
  },
  {
    id: 'ak47',
    category: 'rifle',
    ammo: 30,
    fireMode: 'auto',
    fireIntervalTicks: 5,
    projectile: { kind: 'bullet', speed: 65, damage: 23, spreadDeg: 2.5, count: 1, gravity: 0, bounce: 0, fuse: 0, radius: 0, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 0.45, up: 0.6, forward: 0 },
    knockback: 2.2,
    thrownDamage: 55,
    dropWeight: 0.85,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'ak47', length: 0.85 },
    sound: 'shot.rifle',
    milestone: 'm3',
  },
  {
    id: 'm16',
    category: 'rifle',
    ammo: 30,
    fireMode: 'burst',
    fireIntervalTicks: 3,
    burstCount: 3,
    projectile: { kind: 'bullet', speed: 68, damage: 20, spreadDeg: 1.5, count: 1, gravity: 0, bounce: 0, fuse: 0, radius: 0, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 0.4, up: 0.5, forward: 0 },
    knockback: 2,
    thrownDamage: 55,
    dropWeight: 0.7,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'm16', length: 0.82 },
    sound: 'shot.rifle',
    milestone: 'm6',
  },
  {
    id: 'm1',
    category: 'rifle',
    ammo: 8,
    fireMode: 'semi',
    fireIntervalTicks: 12,
    projectile: { kind: 'bullet', speed: 75, damage: 35, spreadDeg: 0.8, count: 1, gravity: 0, bounce: 0, fuse: 0, radius: 0, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 0.8, up: 1.1, forward: 0 },
    knockback: 3.5,
    thrownDamage: 55,
    dropWeight: 0.65,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'm1', length: 0.9 },
    sound: 'shot.heavy',
    milestone: 'm6',
  },
  {
    id: 'sniper',
    category: 'rifle',
    ammo: 5,
    fireMode: 'semi',
    fireIntervalTicks: 40,
    projectile: { kind: 'bullet', speed: 120, damage: 75, spreadDeg: 0, count: 1, gravity: 0, bounce: 0, fuse: 0, radius: 0, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 1.2, up: 1.6, forward: 0 },
    knockback: 4,
    thrownDamage: 55,
    dropWeight: 0.45,
    twoHanded: true,
    laserSight: true,
    infiniteAmmo: false,
    shape: { kind: 'sniper', length: 1.1 },
    sound: 'shot.sniper',
    milestone: 'm3',
  },
  {
    id: 'sawed-off',
    category: 'rifle',
    ammo: 10,
    fireMode: 'semi',
    fireIntervalTicks: 22,
    projectile: { kind: 'pellets', speed: 50, damage: 18, spreadDeg: 14, count: 5, gravity: 0, bounce: 0, fuse: 0, radius: 0, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 8, up: 1.5, forward: 0 },
    knockback: 5,
    thrownDamage: 55,
    dropWeight: 0.8,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'sawed-off', length: 0.55 },
    sound: 'shot.shotgun',
    milestone: 'm3',
  },
  {
    id: 'military-shotgun',
    category: 'rifle',
    ammo: 10,
    fireMode: 'semi',
    fireIntervalTicks: 20,
    projectile: { kind: 'pellets', speed: 55, damage: 5.5, spreadDeg: 6, count: 5, gravity: 0, bounce: 0, fuse: 0, radius: 0, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 3, up: 1, forward: 0 },
    knockback: 3,
    thrownDamage: 55,
    dropWeight: 0.7,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'military-shotgun', length: 0.75 },
    sound: 'shot.shotgun',
    milestone: 'm6',
  },
  {
    id: 'bouncer',
    category: 'rifle',
    ammo: 30,
    fireMode: 'auto',
    fireIntervalTicks: 6,
    projectile: { kind: 'bullet', speed: 45, damage: 45, spreadDeg: 1, count: 1, gravity: 0, bounce: 6, fuse: 0, radius: 0, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 0.4, up: 0.4, forward: 0 },
    knockback: 2.5,
    thrownDamage: 55,
    dropWeight: 0.4,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'bouncer', length: 0.8 },
    sound: 'shot.bounce',
    milestone: 'm6',
  },
  {
    id: 'grenade-launcher',
    category: 'explosive',
    ammo: 5,
    fireMode: 'semi',
    fireIntervalTicks: 28,
    projectile: { kind: 'grenade', speed: 22, damage: 65, spreadDeg: 1, count: 1, gravity: 18, bounce: 3, fuse: 66, radius: 2.4, explodeDamage: 65, explodeImpulse: 12, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 1.2, up: 1, forward: 0 },
    knockback: 6,
    thrownDamage: 55,
    dropWeight: 0.55,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'grenade-launcher', length: 0.7 },
    sound: 'shot.launcher',
    milestone: 'm3',
  },
  {
    id: 'thruster',
    category: 'explosive',
    ammo: 20,
    fireMode: 'semi',
    fireIntervalTicks: 12,
    projectile: { kind: 'rocket', speed: 28, damage: 0, spreadDeg: 0, count: 1, gravity: 0, bounce: 0, fuse: 40, radius: 1.6, explodeDamage: 15, explodeImpulse: 16, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 1.6, up: 0.2, forward: 0 },
    knockback: 10,
    thrownDamage: 55,
    dropWeight: 0.35,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'thruster', length: 0.7 },
    sound: 'shot.rocket',
    milestone: 'm6',
  },
  {
    id: 'rpg',
    category: 'explosive',
    ammo: 3,
    fireMode: 'semi',
    fireIntervalTicks: 40,
    projectile: { kind: 'rocket', speed: 32, damage: 300, spreadDeg: 0, count: 1, gravity: 0, bounce: 0, fuse: 0, radius: 3.2, explodeDamage: 300, explodeImpulse: 18, status: 'none', warningTicks: 0, beamTicks: 0, rare: true },
    recoil: { back: 6, up: 2, forward: 0 },
    knockback: 14,
    thrownDamage: 55,
    dropWeight: 0.15,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'rpg', length: 1 },
    sound: 'shot.rocket',
    milestone: 'm3',
  },
  {
    id: 'snake-gun',
    category: 'snake',
    ammo: 6,
    fireMode: 'semi',
    fireIntervalTicks: 16,
    projectile: { kind: 'creature', speed: 10, damage: 5, count: 1, gravity: 16, bounce: 0, fuse: 0, radius: 0.25, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 0.4, up: 0.3, forward: 0 },
    knockback: 1,
    thrownDamage: 55,
    dropWeight: 0.45,
    twoHanded: false,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'snake-gun', length: 0.55 },
    sound: 'shot.snake',
    milestone: 'm6',
  },
  {
    id: 'snake-shotgun',
    category: 'snake',
    ammo: 10,
    fireMode: 'semi',
    fireIntervalTicks: 22,
    projectile: { kind: 'creature', speed: 12, damage: 5, spreadDeg: 12, count: 3, gravity: 16, bounce: 0, fuse: 0, radius: 0.25, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 2, up: 0.6, forward: 0 },
    knockback: 1,
    thrownDamage: 55,
    dropWeight: 0.35,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'snake-shotgun', length: 0.6 },
    sound: 'shot.snake',
    milestone: 'm6',
  },
  {
    id: 'snake-grenade',
    category: 'snake',
    ammo: 5,
    fireMode: 'semi',
    fireIntervalTicks: 28,
    projectile: { kind: 'burst-into', speed: 18, damage: 5, count: 1, gravity: 16, bounce: 2, fuse: 70, radius: 1.2, explodeDamage: 0, explodeImpulse: 4, status: 'none', burstInto: 'snake', burstCount: 4, warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 1, up: 0.8, forward: 0 },
    knockback: 2,
    thrownDamage: 55,
    dropWeight: 0.3,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'snake-grenade', length: 0.65 },
    sound: 'shot.launcher',
    milestone: 'm6',
  },
  {
    id: 'snake-launcher',
    category: 'snake',
    ammo: 3,
    fireMode: 'semi',
    fireIntervalTicks: 30,
    projectile: { kind: 'creature', speed: 14, damage: 25, count: 1, gravity: 12, bounce: 0, fuse: 0, radius: 0.45, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 1.4, up: 0.6, forward: 0 },
    knockback: 3,
    thrownDamage: 55,
    dropWeight: 0.22,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'snake-launcher', length: 0.8 },
    sound: 'shot.snake',
    milestone: 'm6',
  },
  {
    id: 'snake-minigun',
    category: 'snake',
    ammo: 40,
    fireMode: 'auto',
    fireIntervalTicks: 4,
    projectile: { kind: 'creature', speed: 12, damage: 5, spreadDeg: 6, count: 1, gravity: 16, bounce: 0, fuse: 0, radius: 0.22, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 0.7, up: 0.2, forward: 0 },
    knockback: 1,
    thrownDamage: 55,
    dropWeight: 0.2,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'snake-minigun', length: 0.85 },
    sound: 'shot.snake',
    milestone: 'm6',
  },
  {
    // Keep the legacy id so saved weapon selections continue to resolve.
    id: 'flying-snake-launcher',
    category: 'snake',
    ammo: 3,
    fireMode: 'semi',
    fireIntervalTicks: 30,
    projectile: { kind: 'creature', speed: 16, damage: 25, count: 1, gravity: 12, bounce: 0, fuse: 0, radius: 0.45, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 1.4, up: 0.4, forward: 0 },
    knockback: 3,
    thrownDamage: 55,
    dropWeight: 0.18,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'flying-snake', length: 0.85 },
    sound: 'shot.snake',
    milestone: 'm6',
  },
  {
    id: 'lava-spike-ball',
    category: 'lava',
    ammo: 5,
    fireMode: 'semi',
    fireIntervalTicks: 26,
    projectile: { kind: 'burst-into', speed: 16, damage: 30, count: 1, gravity: 14, bounce: 1, fuse: 50, radius: 1.8, explodeDamage: 20, explodeImpulse: 6, status: 'none', burstInto: 'spike', burstCount: 25, warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 1.2, up: 0.8, forward: 0 },
    knockback: 4,
    thrownDamage: 55,
    dropWeight: 0.28,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'lava-spike-ball', length: 0.7 },
    sound: 'shot.lava',
    milestone: 'm6',
  },
  {
    id: 'lava-beam',
    category: 'lava',
    ammo: 25,
    fireMode: 'semi',
    fireIntervalTicks: 50,
    projectile: { kind: 'beam', speed: 0, damage: 215, count: 1, gravity: 0, bounce: 0, fuse: 0, radius: 0.12, explodeDamage: 0, explodeImpulse: 0, status: 'burn', warningTicks: 24, beamTicks: 18, rare: false },
    recoil: { back: 0.6, up: 0.2, forward: 0 },
    knockback: 3,
    thrownDamage: 55,
    dropWeight: 0.22,
    twoHanded: true,
    laserSight: true,
    infiniteAmmo: false,
    shape: { kind: 'lava-beam', length: 0.9 },
    sound: 'shot.beam',
    milestone: 'm6',
  },
  {
    id: 'lava-stream',
    category: 'lava',
    ammo: 600,
    fireMode: 'hold',
    fireIntervalTicks: 2,
    projectile: { kind: 'beam', speed: 0, damage: 1, count: 1, gravity: 0, bounce: 0, fuse: 0, radius: 0.16, explodeDamage: 0, explodeImpulse: 0, status: 'burn', warningTicks: 0, beamTicks: 2, rare: false },
    recoil: { back: 0.8, up: 0.1, forward: 0 },
    knockback: 8,
    thrownDamage: 55,
    dropWeight: 0.25,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'lava-stream', length: 0.8 },
    sound: 'shot.stream',
    milestone: 'm6',
  },
  {
    id: 'lava-spray',
    category: 'lava',
    ammo: 40,
    fireMode: 'auto',
    fireIntervalTicks: 5,
    projectile: { kind: 'grenade', speed: 18, damage: 12, spreadDeg: 10, count: 1, gravity: 20, bounce: 0, fuse: 40, radius: 1.0, explodeDamage: 12, explodeImpulse: 4, status: 'burn', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 0.5, up: 0.3, forward: 0 },
    knockback: 6,
    thrownDamage: 55,
    dropWeight: 0.3,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'lava-spray', length: 0.7 },
    sound: 'shot.lava',
    milestone: 'm6',
  },
  {
    id: 'lava-spike-gun',
    category: 'lava',
    ammo: 25,
    fireMode: 'semi',
    fireIntervalTicks: 10,
    projectile: { kind: 'burst-into', speed: 40, damage: 12, count: 1, gravity: 0, bounce: 0, fuse: 0, radius: 0.8, explodeDamage: 10, explodeImpulse: 3, status: 'none', burstInto: 'spike', burstCount: 3, warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 0.6, up: 0.4, forward: 0 },
    knockback: 2,
    thrownDamage: 55,
    dropWeight: 0.32,
    twoHanded: false,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'lava-spike-gun', length: 0.6 },
    sound: 'shot.lava',
    milestone: 'm6',
  },
  {
    id: 'sword',
    category: 'melee',
    ammo: 999,
    fireMode: 'semi',
    fireIntervalTicks: 16,
    projectile: { kind: 'melee', speed: 8, damage: 68, count: 1, gravity: 0, bounce: 0, fuse: 0, radius: 0.7, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 0, up: 0, forward: 6 },
    knockback: 5,
    thrownDamage: 55,
    dropWeight: 0.4,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: true,
    shape: { kind: 'sword', length: 1.1 },
    sound: 'melee.sword',
    milestone: 'm6',
  },
  {
    id: 'spear',
    category: 'melee',
    ammo: 999,
    fireMode: 'semi',
    fireIntervalTicks: 18,
    projectile: { kind: 'melee', speed: 10, damage: 20, count: 1, gravity: 0, bounce: 0, fuse: 0, radius: 1.1, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 0, up: 0, forward: 5 },
    knockback: 8,
    thrownDamage: 55,
    dropWeight: 0.4,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: true,
    shape: { kind: 'spear', length: 1.4 },
    sound: 'melee.spear',
    milestone: 'm6',
  },
  {
    id: 'blink-dagger',
    category: 'melee',
    ammo: 25,
    fireMode: 'semi',
    fireIntervalTicks: 20,
    projectile: { kind: 'melee', speed: 14, damage: 36, count: 1, gravity: 0, bounce: 0, fuse: 0, radius: 0.6, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 0, up: 0, forward: 0 },
    knockback: 3,
    thrownDamage: 55,
    dropWeight: 0.25,
    twoHanded: false,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'blink-dagger', length: 0.45 },
    sound: 'melee.blink',
    milestone: 'm6',
  },
  {
    id: 'time-bubble',
    category: 'other',
    ammo: 5,
    fireMode: 'semi',
    fireIntervalTicks: 30,
    projectile: { kind: 'field', speed: 16, damage: 12.5, count: 1, gravity: 0, bounce: 0, fuse: 90, radius: 2.2, explodeDamage: 0, explodeImpulse: 0, status: 'bubble', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 0.4, up: 0.2, forward: 0 },
    knockback: 2,
    thrownDamage: 55,
    dropWeight: 0.2,
    twoHanded: false,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'time-bubble', length: 0.5 },
    sound: 'field.bubble',
    milestone: 'm6',
  },
  {
    id: 'laser',
    category: 'other',
    ammo: 60,
    fireMode: 'auto',
    fireIntervalTicks: 3,
    projectile: { kind: 'bullet', speed: 90, damage: 10, spreadDeg: 0.4, count: 1, gravity: 0, bounce: 0, fuse: 0, radius: 0, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 0.2, up: 0.1, forward: 0 },
    knockback: 9,
    thrownDamage: 55,
    dropWeight: 0.3,
    twoHanded: true,
    laserSight: true,
    infiniteAmmo: false,
    shape: { kind: 'laser', length: 0.85 },
    sound: 'shot.laser',
    milestone: 'm6',
  },
  {
    id: 'ice-gun',
    category: 'other',
    ammo: 40,
    fireMode: 'auto',
    fireIntervalTicks: 5,
    projectile: { kind: 'bullet', speed: 40, damage: 7.7, spreadDeg: 2, count: 1, gravity: 0, bounce: 0, fuse: 0, radius: 0, explodeDamage: 0, explodeImpulse: 0, status: 'slow', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 0.25, up: 0.15, forward: 0 },
    knockback: 1.5,
    thrownDamage: 55,
    dropWeight: 0.35,
    twoHanded: false,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'ice-gun', length: 0.6 },
    sound: 'shot.ice',
    milestone: 'm6',
  },
  {
    id: 'black-hole',
    category: 'other',
    ammo: 1,
    fireMode: 'semi',
    fireIntervalTicks: 40,
    projectile: { kind: 'field', speed: 10, damage: 999, count: 1, gravity: 0, bounce: 0, fuse: 180, radius: 4.5, explodeDamage: 999, explodeImpulse: 20, status: 'none', warningTicks: 0, beamTicks: 0, rare: true },
    recoil: { back: 1, up: 0.4, forward: 0 },
    knockback: 0,
    thrownDamage: 55,
    dropWeight: 0.08,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'black-hole', length: 0.55 },
    sound: 'field.hole',
    milestone: 'm6',
  },
  {
    id: 'glue-gun',
    category: 'other',
    ammo: 40,
    fireMode: 'auto',
    fireIntervalTicks: 5,
    projectile: { kind: 'field', speed: 28, damage: 1, spreadDeg: 3, count: 1, gravity: 8, bounce: 0, fuse: 80, radius: 0.8, explodeDamage: 0, explodeImpulse: 0, status: 'glue', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 0.2, up: 0.1, forward: 0 },
    knockback: 0.5,
    thrownDamage: 55,
    dropWeight: 0.32,
    twoHanded: false,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'glue-gun', length: 0.55 },
    sound: 'shot.glue',
    milestone: 'm6',
  },
  {
    id: 'minigun',
    category: 'other',
    ammo: 200,
    fireMode: 'auto',
    fireIntervalTicks: 2,
    projectile: { kind: 'bullet', speed: 70, damage: 5, spreadDeg: 5, count: 1, gravity: 0, bounce: 0, fuse: 0, radius: 0, explodeDamage: 0, explodeImpulse: 0, status: 'none', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 1.1, up: 0.15, forward: 0 },
    knockback: 1.2,
    thrownDamage: 55,
    dropWeight: 0.28,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'minigun', length: 0.95 },
    sound: 'shot.minigun',
    milestone: 'm6',
  },
  {
    id: 'flamethrower',
    category: 'other',
    ammo: 300,
    fireMode: 'hold',
    fireIntervalTicks: 2,
    projectile: { kind: 'field', speed: 14, damage: 1, spreadDeg: 8, count: 1, gravity: 2, bounce: 0, fuse: 24, radius: 0.7, explodeDamage: 0, explodeImpulse: 0, status: 'burn', warningTicks: 0, beamTicks: 0, rare: false },
    recoil: { back: 0.15, up: 0.05, forward: 0 },
    knockback: 0.8,
    thrownDamage: 55,
    dropWeight: 0.3,
    twoHanded: true,
    laserSight: false,
    infiniteAmmo: false,
    shape: { kind: 'flamethrower', length: 0.85 },
    sound: 'shot.flame',
    milestone: 'm6',
  },
  {
    id: 'office-stapler',
    category: 'other',
    ammo: 16,
    fireMode: 'auto',
    fireIntervalTicks: 7,
    projectile: { kind: 'bullet', speed: 30, damage: 14, spreadDeg: 5, fuse: 12 },
    recoil: { back: 0.12, up: 0.02 },
    knockback: 0.7,
    thrownDamage: 24,
    throwProfile: { speed: 18, spin: -9 },
    dropWeight: 1.3,
    shape: { kind: 'office-stapler', length: 0.48 },
    sound: 'shot.small',
    milestone: 'm6',
  },
  {
    id: 'office-chair',
    category: 'other',
    ammo: 1,
    fireMode: 'semi',
    fireIntervalTicks: 24,
    projectile: { kind: 'bullet', speed: 15, damage: 30 },
    recoil: {},
    thrownDamage: 30,
    throwProfile: { attackThrows: true, speed: 15, halfWidth: 0.42, halfHeight: 0.46, density: 0.7, friction: 0.025, upright: true, knockback: 13, hitRadius: 0.92 },
    dropWeight: 0.9,
    twoHanded: true,
    shape: { kind: 'office-chair', length: 0.85 },
    sound: 'shot.small',
    milestone: 'm6',
  },
  {
    id: 'office-monitor',
    category: 'other',
    ammo: 1,
    fireMode: 'semi',
    fireIntervalTicks: 24,
    projectile: { kind: 'bullet', speed: 14, damage: 60 },
    recoil: {},
    thrownDamage: 60,
    throwProfile: { attackThrows: true, speed: 14, halfWidth: 0.38, halfHeight: 0.3, density: 1, spin: -5, shatters: true, knockback: 6, hitRadius: 0.85 },
    dropWeight: 0.75,
    twoHanded: true,
    shape: { kind: 'office-monitor', length: 0.76 },
    sound: 'shot.small',
    milestone: 'm6',
  },
  {
    id: 'office-keyboard',
    category: 'melee',
    ammo: 999,
    fireMode: 'auto',
    fireIntervalTicks: 15,
    projectile: { kind: 'melee', speed: 0, damage: 24, radius: 1.05 },
    recoil: {},
    knockback: 3.5,
    thrownDamage: 30,
    throwProfile: { speed: 19, spin: -12, knockback: 3 },
    dropWeight: 1.1,
    infiniteAmmo: true,
    shape: { kind: 'office-keyboard', length: 0.8 },
    sound: 'melee.sword',
    milestone: 'm6',
  },
  {
    id: 'office-mug',
    category: 'other',
    ammo: 1,
    fireMode: 'semi',
    fireIntervalTicks: 15,
    projectile: { kind: 'bullet', speed: 23, damage: 35 },
    recoil: {},
    thrownDamage: 35,
    throwProfile: { attackThrows: true, speed: 23, halfWidth: 0.17, halfHeight: 0.18, density: 0.4, spin: -14, shatters: true, knockback: 3 },
    dropWeight: 1.2,
    shape: { kind: 'office-mug', length: 0.34 },
    sound: 'shot.small',
    milestone: 'm6',
  },
  {
    id: 'return-disc',
    category: 'other',
    ammo: 1,
    fireMode: 'semi',
    fireIntervalTicks: 18,
    projectile: { kind: 'return-disc', speed: 18, damage: 24, radius: 8, fuse: 180 },
    recoil: {},
    knockback: 1.5,
    dropWeight: 0.75,
    infiniteAmmo: true,
    shape: { kind: 'return-disc', length: 0.58 },
    sound: 'shot.disc',
    milestone: 'm6',
  },
  {
    id: 'siphon',
    category: 'other',
    ammo: 3,
    fireMode: 'semi',
    fireIntervalTicks: 36,
    projectile: { kind: 'siphon', speed: 0, damage: 18, radius: 4, fuse: 8 },
    recoil: { back: 0.2 },
    knockback: 0.5,
    dropWeight: 0.35,
    shape: { kind: 'siphon', length: 0.56 },
    sound: 'shot.siphon',
    milestone: 'm6',
  },
];

/** Distinctive public names (PLAN §9). Ids stay stable for data/toggles. */
const DISPLAY_NAMES: Record<string, string> = {
  fists: 'Fists',
  pistol: 'Pistol',
  revolver: 'Revolver',
  deagle: 'Hand Cannon',
  uzi: 'Spray Pistol',
  'god-pistol': 'Oracle Pistol',
  ak47: 'Battle Rifle',
  m16: 'Burst Rifle',
  m1: 'Scout Rifle',
  sniper: 'Longshot',
  'sawed-off': 'Boomstick',
  'military-shotgun': 'Tactical Scatter',
  bouncer: 'Ricochet Rifle',
  'grenade-launcher': 'Arc Launcher',
  thruster: 'Pusher',
  rpg: 'Warhead',
  'snake-gun': 'Viper Pistol',
  'snake-shotgun': 'Viper Scatter',
  'snake-grenade': 'Viper Grenade',
  'snake-launcher': 'Viper Launcher',
  'snake-minigun': 'Viper Minigun',
  'flying-snake-launcher': 'Heavy Viper',
  'lava-spike-ball': 'Magma Orb',
  'lava-beam': 'Magma Beam',
  'lava-stream': 'Magma Stream',
  'lava-spray': 'Magma Spray',
  'lava-spike-gun': 'Magma Spike',
  sword: 'Cleaver',
  spear: 'Pike',
  'blink-dagger': 'Blink Knife',
  'time-bubble': 'Stasis Orb',
  laser: 'Beam Pistol',
  'ice-gun': 'Frost Gun',
  'black-hole': 'Void Well',
  'glue-gun': 'Goo Gun',
  minigun: 'Rotary Cannon',
  flamethrower: 'Flame Hose',
  'office-stapler': 'Stapler',
  'office-chair': 'Office Chair',
  'office-monitor': 'Monitor',
  'office-keyboard': 'Keyboard',
  'office-mug': 'Coffee Mug',
  'return-disc': 'Return Disc',
  siphon: 'Siphon',
};

export const WEAPON_DEFS: WeaponDef[] = raw.map((def) =>
  WeaponDefSchema.parse({ ...def, displayName: DISPLAY_NAMES[def.id] ?? titleCase(def.id) }),
);

function titleCase(id: string): string {
  return id
    .split('-')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

export function weaponDisplayName(def: WeaponDef | string): string {
  if (typeof def === 'string') {
    const found = WEAPON_BY_ID.get(def)?.def;
    return found?.displayName ?? DISPLAY_NAMES[def] ?? titleCase(def);
  }
  return def.displayName ?? DISPLAY_NAMES[def.id] ?? titleCase(def.id);
}

export const WEAPON_BY_ID = new Map(WEAPON_DEFS.map((d, i) => [d.id, { def: d, index: i }]));

export function weaponIndex(id: string): number {
  const found = WEAPON_BY_ID.get(id);
  if (!found) throw new Error(`Unknown weapon ${id}`);
  return found.index;
}

export function weaponByIndex(index: number): WeaponDef {
  const def = WEAPON_DEFS[index];
  if (!def) throw new Error(`Unknown weapon index ${index}`);
  return def;
}

export function droppableWeapons(enabled: string[] | 'all'): WeaponDef[] {
  return WEAPON_DEFS.filter((d) => d.dropWeight > 0 && (enabled === 'all' ? !isOfficeWeapon(d.id) : enabled.includes(d.id)));
}

export const OFFICE_WEAPON_IDS = ['office-stapler', 'office-chair', 'office-monitor', 'office-keyboard', 'office-mug'] as const;

export function isOfficeWeapon(id: string): boolean {
  return (OFFICE_WEAPON_IDS as readonly string[]).includes(id);
}
